import React from "react";
import { NavLink } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/20/solid";

const CardDocument = ({ item }) => {
  return (
    <div className="group relative flex h-full min-h-[12rem] flex-col overflow-hidden rounded-2xl border border-wa-border bg-wa-panel shadow-[0_20px_50px_-38px_rgba(0,0,0,0.42)] ring-1 ring-black/[0.04] transition duration-300 hover:-translate-y-0.5 hover:border-wa-accent/35 hover:shadow-[0_26px_56px_-30px_rgba(0,0,0,0.48)] dark:bg-wa-panel2/95 dark:shadow-[0_24px_60px_-36px_rgba(0,0,0,0.62)] dark:ring-white/[0.06] dark:hover:border-wa-accent/40">
      <div
        className="pointer-events-none absolute inset-x-4 top-0 h-px bg-gradient-to-r from-transparent via-wa-accent/55 to-transparent opacity-90"
        aria-hidden
      />
      <div className="flex flex-1 flex-col p-5 sm:p-6">
        <h2 className="text-lg font-semibold tracking-tight text-wa-text sm:text-xl">
          {item?.title}
        </h2>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-wa-muted sm:text-[15px]">
          {item?.subtitle}
        </p>
        <NavLink
          to={item.href}
          className="mt-5 inline-flex min-h-[2.75rem] w-full touch-manipulation items-center justify-center gap-2 rounded-xl bg-wa-accent px-4 py-2.5 text-sm font-semibold text-wa-onaccent shadow-sm transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent active:scale-[0.99] sm:w-auto sm:self-start"
        >
          <span>{item?.button}</span>
          <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden />
        </NavLink>
      </div>
    </div>
  );
};

export default CardDocument;
